import { render, staticRenderFns } from "./ProductStatus.vue?vue&type=template&id=84eb9236&scoped=true&"
import script from "./ProductStatus.vue?vue&type=script&lang=js&"
export * from "./ProductStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProductStatus.vue?vue&type=style&index=0&id=84eb9236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eb9236",
  null
  
)

export default component.exports